// Travel.js
import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import travelServicesImage from '../assets/travel-services.png';
import TravelScope from '../components/TravelScope';
import TravelProcess from '../components/TravelProcess';
import TravelDestinations from '../components/TravelDestinations';
import TravelDeliverables from '../components/TravelDeliverables';

const Travel = () => {
  return (
    <div>
      {/* Hero Section */}
      <section className="py-16 px-6 bg-white">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            {/* Left Content */}
            <motion.div 
              className="text-left"
              initial={{ opacity: 0, x: -50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8, ease: "easeOut" }}
            >
              <motion.h1 
                className="text-4xl md:text-5xl lg:text-5xl font-inter font-bold text-acBlack leading-tight"
                initial={{ opacity: 0, y: 20 }} 
                animate={{ opacity: 1, y: 0 }} 
                transition={{ duration: 1, delay: 0.3 }}
              >
                Travel & Immigration <br /><span className="text-2xl font-semibold">Advisory & Documentation Support</span>
              </motion.h1>
              
              <motion.p 
                className="text-lg text-gray-600 mt-6 max-w-2xl"
                initial={{ opacity: 0, y: 20 }} 
                animate={{ opacity: 1, y: 0 }} 
                transition={{ duration: 1, delay: 0.5 }}
              >
                We help applicants from across Africa plan, organize, and quality-check visa/immigration files. Our role is advisory and administrative: route guidance, document checklists, background certificates, interview practice, and file assembly standards, so your submission is clear and complete.
              </motion.p>

              <motion.p 
                className="text-sm text-gray-500 mt-4 max-w-2xl italic"
                initial={{ opacity: 0, y: 20 }} 
                animate={{ opacity: 1, y: 0 }} 
                transition={{ duration: 1, delay: 0.6 }}
              >
                We are not a law firm and do not guarantee approvals.
              </motion.p>
              
              <motion.div 
                className="mt-8 flex flex-col sm:flex-row items-start gap-4"
                initial={{ opacity: 0, scale: 0.8 }} 
                animate={{ opacity: 1, scale: 1 }} 
                transition={{ duration: 0.6, delay: 0.8 }}
              >
                <Link 
                  to="/contact" 
                  className="bg-acBlack hover:bg-gray-800 text-white font-semibold px-8 py-3 rounded-lg transition-colors"
                >
                  Book an Advisory Call
                </Link>
              </motion.div>
            </motion.div>

            {/* Right Image */}
            <motion.div 
              className="relative"
              initial={{ opacity: 0, x: 50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8, delay: 0.4 }}
            >
              <img
                src={travelServicesImage}
                alt="Travel & Immigration Services"
                className="w-full h-auto"
              />
            </motion.div>
          </div>
        </div>
      </section>

      {/* Additional sections can be added here */}
      {/* What We Do Section */}
<TravelScope />
<TravelProcess />
<TravelDestinations />
<TravelDeliverables />
    </div>
  );
};

export default Travel;
